import { useMemo } from 'react';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
} from 'reactstrap';

import Navigator from 'src/components/Navigator';
import DocumentManager from 'src/modules/3rd-party-management/components/document-management';
import {
    ROUTE_PATH_ADMIN_DASHBOARD,
    ROUTE_PATH_ADMIN_DOCUMENT_MANAGEMENT,
} from 'src/modules/3rd-party-management/constants';

const DocumentManagement = ({
    t,
}) => {
    const navigatorOptions = useMemo(() => ({
        translate: false,
        breadCrumbs: [
            {
                title: t('SIP'),
                link: ROUTE_PATH_ADMIN_DASHBOARD,
            },
            {
                title: t('Documents'),
                link: ROUTE_PATH_ADMIN_DOCUMENT_MANAGEMENT,
            },
        ],
        pageTitle: t('Documents'),
    }), [t]);

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator {...navigatorOptions} />
                    </Col>
                </Row>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <DocumentManager />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default withNamespaces()(DocumentManagement);
